import { createFileRoute } from "@tanstack/react-router";
import AdminAudioNewPage from "@/pages/admin/lms/audio/new";
import { useLmsPermissions } from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms/audio/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllMaterials, userCanViewAllMaterials } = useLmsPermissions();

  return (
    <AdminAudioNewPage
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllMaterials={userCanViewAllMaterials}
    />
  );
}
